import styled from "styled-components";
import "./Main.css";
import PostModal from "./PostModal";
import { useState } from "react";

const Main = (props) => {
  const [showModal, setShowModal] = useState("close");

  const handleClick = (e) => {
    e.preventDefault();
    if (e.target !== e.currentTarget) {
      return;
    }

    switch (showModal) {
      case "open":
        setShowModal("close");
        break;
      case "close":
        setShowModal("open");
        break;
      default:
        setShowModal("close");
        break;
    }
  };
  return (
    <Container>
      <ShareBox>
        <div className="daedae">
          <img className="usr__icon" src="/images/user.svg" alt="user" />
          <button onClick={handleClick} className="post-space">
            Start a Post
          </button>
        </div>
        <div>
          <button>
            <img src="/images/photo-icon.svg" alt="Add photo" />
            <span>Photo</span>
          </button>
          <button>
            <img src="/images/video-icon.svg" alt="Add video" />
            <span>Video</span>
          </button>
          <button>
            <img src="/images/event-icon.svg" alt="Add event" />
            <span>Event</span>
          </button>
          <button>
            <img src="/images/article-icon.svg" alt="Add Article" />
            <span>Article</span>
          </button>
        </div>
      </ShareBox>
      <div>
        {/* 1st post */}
        <Article>
          <SharedActor>
            <a>
              <img
                src="https://media-exp1.licdn.com/dms/image/C5603AQEArKx01usNvw/profile-displayphoto-shrink_100_100/0/1625204661298?e=1652918400&v=beta&t=8p_gxN1YPKz0UK74iQq2iMOCICvHdAQVxBOPGWG_z-4"
                alt="Diwaan Chandar C S's Profile Picture"
              />
              <div>
                <span className="post__title">DIWAAN CHANDAR C S</span>
                <span className="post__info">
                  Campus Evangelist at HackerEarth | Student at Bitsathy
                </span>
                <span className="post__date">8 hr ago</span>
              </div>
            </a>
            <button>
              <img src="/images/ellipsis.svg" alt="more" />
            </button>
          </SharedActor>
          <Description>
            First job is always special!! I'm ready for my next chapter!!
            Excited to start my position as #intern Zoho!! Thanks for all the
            well-wishers who really supports me, getting this position!!
          </Description>
          <SharedImg>
            <a>
              <img
                src="https://media-exp1.licdn.com/dms/image/C5622AQG5e7f7e6qI0g/feedshare-shrink_2048_1536/0/1647684802123?e=1650499200&v=beta&t=v-4KHlxPi-U47IkSo5u671Fg6eSsU6ot8H66vtC7X0w"
                alt="post image"
              />
            </a>
          </SharedImg>
          <SocialCounts>
            <li className="list__social">
              <button>
                <img
                  className="second__reaction"
                  src="https://static-exp1.licdn.com/sc/h/8ekq8gho1ruaf8i7f86vd1ftt"
                  alt="like"
                />
                <img
                  className="second__reaction"
                  src="https://static-exp1.licdn.com/sc/h/cpho5fghnpme8epox8rdcds22"
                  alt="like"
                />
                <span>103k</span>
              </button>
            </li>
            <li className="comments">
              <a> 23,950 comments</a>
            </li>
          </SocialCounts>
          <SocialActions className="social__act">
            <button>
              <img src="/images/like.svg" alt="like" />
              <span>Like</span>
            </button>
            <button>
              <img className="comm" src="/images/comment.svg" alt="comments" />
              <span>Comment</span>
            </button>
            <button>
              <img src="/images/share.svg" alt="share" />
              <span>Share</span>
            </button>
            <div className="send__button">
              <button>
                <img src="/images/send.svg" alt="send" />
                <span>Send</span>
              </button>
            </div>
          </SocialActions>
        </Article>
        {/* 2nd post */}
        <Article>
          <SharedActor>
            <a>
              <img
                src="https://media-exp1.licdn.com/dms/image/C4E03AQEAci5d65FJ8g/profile-displayphoto-shrink_400_400/0/1643187802617?e=1652918400&v=beta&t=CabYK8kwEgOm9Qh3V-QVoKy2ER3qzoknb5q5QVpHhic"
                alt="Shiva Pranav S's Profile Picture"
              />
              <div>
                <span className="post__title">SHIVA PRANAV S</span>
                <span className="post__info">
                  Web Developer | Student at Bannari Amman Institute of
                  Technology
                </span>
                <span className="post__date">48 mins ago</span>
              </div>
            </a>
            <button>
              <img src="/images/ellipsis.svg" alt="more" />
            </button>
          </SharedActor>
          <Description>
            Successfully participated in #HAB59 hackathon organized by MIT Art
            Design and Technology University, Pune in Business Application
            category.
          </Description>
          <SharedImg>
            <a>
              <img
                src="https://i.ibb.co/6m7Bm3D/1639409479389-page-0001.jpg"
                alt="post image"
              />
            </a>
          </SharedImg>
          <SocialCounts>
            <li className="list__social">
              <button>
                <img
                  className="second__reaction"
                  src="https://static-exp1.licdn.com/sc/h/8ekq8gho1ruaf8i7f86vd1ftt"
                  alt="like"
                />
                <img
                  className="second__reaction"
                  src="https://static-exp1.licdn.com/sc/h/cpho5fghnpme8epox8rdcds22"
                  alt="like"
                />
                <span>103k</span>
              </button>
            </li>
            <li className="comments">
              <a> 23,950 comments</a>
            </li>
          </SocialCounts>
          <SocialActions className="social__act">
            <button>
              <img src="/images/like.svg" alt="like" />
              <span>Like</span>
            </button>
            <button>
              <img className="comm" src="/images/comment.svg" alt="comments" />
              <span>Comment</span>
            </button>
            <button>
              <img src="/images/share.svg" alt="share" />
              <span>Share</span>
            </button>
            <div className="send__button">
              <button>
                <img src="/images/send.svg" alt="send" />
                <span>Send</span>
              </button>
            </div>
          </SocialActions>
        </Article>
        {/* 3rd post */}
        <Article>
          <SharedActor>
            <a>
              <img
                src="https://media-exp1.licdn.com/dms/image/C5603AQF_msQaJghejQ/profile-displayphoto-shrink_400_400/0/1645280029503?e=1652918400&v=beta&t=6DhV-yfe0sgNkoPi2xRKZiE4XBPNat268GnyURdEAj4"
                alt="RANJITH D's Profile Picture"
              />
              <div>
                <span className="post__title">RANJITH D</span>
                <span className="post__info">
                  IEEE Member | Student at Bannari Amman Institute of Technology
                </span>
                <span className="post__date">3d ago</span>
              </div>
            </a>
            <button>
              <img src="/images/ellipsis.svg" alt="more" />
            </button>
          </SharedActor>
          <Description>
            Lost the Ideathon in a small space - results in special mention! But
            happy to show my full potential in every event.
          </Description>
          <SharedImg>
            <a>
              <img
                src="https://media-exp1.licdn.com/dms/image/C4E2DAQEv4YKOja65Uw/profile-treasury-image-shrink_800_800/0/1628922149556?e=1647802800&v=beta&t=mWDJqIn_aRVYKEvD--R3xOwWsKBH2tHtdNxau-EaTuM"
                alt="post image"
              />
            </a>
          </SharedImg>
          <SocialCounts>
            <li className="list__social">
              <button>
                <img
                  className="second__reaction"
                  src="https://static-exp1.licdn.com/sc/h/8ekq8gho1ruaf8i7f86vd1ftt"
                  alt="like"
                />
                <img
                  className="second__reaction"
                  src="https://static-exp1.licdn.com/sc/h/cpho5fghnpme8epox8rdcds22"
                  alt="like"
                />
                <span>103k</span>
              </button>
            </li>
            <li className="comments">
              <a> 23,950 comments</a>
            </li>
          </SocialCounts>
          <SocialActions className="social__act">
            <button>
              <img src="/images/like.svg" alt="like" />
              <span>Like</span>
            </button>
            <button>
              <img className="comm" src="/images/comment.svg" alt="comments" />
              <span>Comment</span>
            </button>
            <button>
              <img src="/images/share.svg" alt="share" />
              <span>Share</span>
            </button>
            <div className="send__button">
              <button>
                <img src="/images/send.svg" alt="send" />
                <span>Send</span>
              </button>
            </div>
          </SocialActions>
        </Article>
        {/* 4th post */}
        <Article>
          <SharedActor>
            <a>
              <img
                src="https://media-exp1.licdn.com/dms/image/C5603AQFVvBehoL90Dw/profile-displayphoto-shrink_400_400/0/1641017005068?e=1652918400&v=beta&t=5vm736Ep264YHIPimaLDe9AAofVT5-Q25YWzpjUW8HQ"
                alt="NIRANJAN V's Profile Picture"
              />
              <div>
                <span className="post__title">NIRANJAN V</span>
                <span className="post__info">
                  Frontend web developer | Student | Freelancer
                </span>
                <span className="post__date">1 hr ago</span>
              </div>
            </a>
            <button>
              <img src="/images/ellipsis.svg" alt="more" />
            </button>
          </SharedActor>
          <Description>Every Developers Dream Desktop setup 💙</Description>
          <SharedImg>
            <a>
              <img
                src="https://media-exp1.licdn.com/dms/image/C4E22AQFnZr4s_gHVrg/feedshare-shrink_800/0/1647322074494?e=1650499200&v=beta&t=9jHqDw_1-jRgFJgxjOiHjWdI9UIj_u7idD9GApZ3Cz8"
                alt="post image"
              />
            </a>
          </SharedImg>
          <SocialCounts>
            <li className="list__social">
              <button>
                <img
                  className="second__reaction"
                  src="https://static-exp1.licdn.com/sc/h/8ekq8gho1ruaf8i7f86vd1ftt"
                  alt="like"
                />
                <img
                  className="second__reaction"
                  src="https://static-exp1.licdn.com/sc/h/cpho5fghnpme8epox8rdcds22"
                  alt="like"
                />
                <span>103k</span>
              </button>
            </li>
            <li className="comments">
              <a> 23,950 comments</a>
            </li>
          </SocialCounts>
          <SocialActions className="social__act">
            <button>
              <img src="/images/like.svg" alt="like" />
              <span>Like</span>
            </button>
            <button>
              <img className="comm" src="/images/comment.svg" alt="comments" />
              <span>Comment</span>
            </button>
            <button>
              <img src="/images/share.svg" alt="share" />
              <span>Share</span>
            </button>
            <div className="send__button">
              <button>
                <img src="/images/send.svg" alt="send" />
                <span>Send</span>
              </button>
            </div>
          </SocialActions>
        </Article>
        {/* 5th post */}
        <Article>
          <SharedActor>
            <a>
              <img
                src="https://pbs.twimg.com/profile_images/1316754075157839872/oZYO9QQ1_400x400.jpg"
                alt="DASAPRAKASH C's Profile Picture"
              />
              <div>
                <span className="post__title">DASAPRAKASH C</span>
                <span className="post__info">
                  Director @ Students For Students Organisation
                </span>
                <span className="post__date">1 hr ago</span>
              </div>
            </a>
            <button>
              <img src="/images/ellipsis.svg" alt="more" />
            </button>
          </SharedActor>
          <Description>
            Greeting from Code Circle BIT,We are very excited to have Hmrishav
            Bandyopadhyay as a speaker for our webinar.
          </Description>
          <SharedImg>
            <a>
              <img
                src="https://media-exp1.licdn.com/dms/image/C5622AQHCxNKosGIJTQ/feedshare-shrink_800/0/1620984498970?e=1650499200&v=beta&t=I2m4sSo0L17d8vdB9l_AX41td65KaIbNRPThF6beQV0"
                alt="post image"
              />
            </a>
          </SharedImg>
          <SocialCounts>
            <li className="list__social">
              <button>
                <img
                  className="second__reaction"
                  src="https://static-exp1.licdn.com/sc/h/8ekq8gho1ruaf8i7f86vd1ftt"
                  alt="like"
                />
                <img
                  className="second__reaction"
                  src="https://static-exp1.licdn.com/sc/h/cpho5fghnpme8epox8rdcds22"
                  alt="like"
                />
                <span>103k</span>
              </button>
            </li>
            <li className="comments">
              <a> 23,950 comments</a>
            </li>
          </SocialCounts>
          <SocialActions className="social__act">
            <button>
              <img src="/images/like.svg" alt="like" />
              <span>Like</span>
            </button>
            <button>
              <img className="comm" src="/images/comment.svg" alt="comments" />
              <span>Comment</span>
            </button>
            <button>
              <img src="/images/share.svg" alt="share" />
              <span>Share</span>
            </button>
            <div className="send__button">
              <button>
                <img src="/images/send.svg" alt="send" />
                <span>Send</span>
              </button>
            </div>
          </SocialActions>
        </Article>
        {/* 6th post */}
        <Article>
          <SharedActor>
            <a>
              <img
                src="https://media-exp1.licdn.com/dms/image/C5603AQGHyO2_H3gLQg/profile-displayphoto-shrink_400_400/0/1620873296611?e=2147483647&v=beta&t=qmeK-9uc2BjrM8Ks5ANJtLYjpNO-vWOe6zyj7jTwmPU"
                alt="ARUN S's Profile Picture"
              />
              <div>
                <span className="post__title">ARUN S</span>
                <span className="post__info">SDE III at Google</span>
                <span className="post__date">18 hr ago</span>
              </div>
            </a>
            <button>
              <img src="/images/ellipsis.svg" alt="more" />
            </button>
          </SharedActor>
          <Description>
            I’m happy to share that I’m starting a new position as a Contract
            Resume Writer at Google! #resumewriter #careercoach #jobs #jobadvice
          </Description>
          <SharedImg>
            <a>
              <img
                src="https://c.tenor.com/xVqd6BJA8bgAAAAM/google-dots.gif"
                alt="post image"
              />
            </a>
          </SharedImg>
          <SocialCounts>
            <li className="list__social">
              <button>
                <img
                  className="second__reaction"
                  src="https://static-exp1.licdn.com/sc/h/8ekq8gho1ruaf8i7f86vd1ftt"
                  alt="like"
                />
                <img
                  className="second__reaction"
                  src="https://static-exp1.licdn.com/sc/h/cpho5fghnpme8epox8rdcds22"
                  alt="like"
                />
                <span>103k</span>
              </button>
            </li>
            <li className="comments">
              <a> 23,950 comments</a>
            </li>
          </SocialCounts>
          <SocialActions className="social__act">
            <button>
              <img src="/images/like.svg" alt="like" />
              <span>Like</span>
            </button>
            <button>
              <img className="comm" src="/images/comment.svg" alt="comments" />
              <span>Comment</span>
            </button>
            <button>
              <img src="/images/share.svg" alt="share" />
              <span>Share</span>
            </button>
            <div className="send__button">
              <button>
                <img src="/images/send.svg" alt="send" />
                <span>Send</span>
              </button>
            </div>
          </SocialActions>
        </Article>
      </div>
      <PostModal showModal={showModal} handleClick={handleClick} />
    </Container>
  );
};

const Container = styled.div`
  font-family: Arial;
  grid-area: main;
  @media (max-width: 768px) {
    padding: 0;
  }
`;

const CommonCard = styled.div`
  text-align: center;
  overflow: hidden;
  width: 550px;
  margin-bottom: 8px;
  background-color: $fff;
  border-radius: 7px;
  position: relative;
  border: none;
  box-shadow: 0 0 0 1px rgb(0 0 0/15%), 0 0 0 rgb(0 0 0/20%);
`;

const ShareBox = styled(CommonCard)`
  display: flex;
  /* position: fixed; */
  flex-direction: column;
  color: #958b7b;
  margin: 0 0 8px;
  background: white;
  margin-left: 100px;
  @media (max-width: 768px) {
    width: 100%;
    min-width: 315px;
    top: 0;
    left: 0;
    margin: 0;
    padding: 0;
    margin-top: -20px;
    div {
      button {
        margin-top: -20px;
      }
      img {
        width: 100%;
        height: 25px;
      }
    }
  }
  div {
    button {
      outline: none;
      color: rgba(0, 0, 0, 0.6);
      font-size: 14px;
      line-height: 1.5;
      min-height: 48px;
      background: transparent;
      border: none;
      display: flex;
      align-items: center;
      font-weight: 500;
    }
    &:first-child {
      display: flex;
      align-items: center;
      padding: 8px 16px 0px 16px;
      img {
        width: 48px;
        border-radius: 50%;
        margin-right: 8px;
        @media (max-width: 768px) {
          width: 20%;
          /* border-radius: 50%; */
          height: 66px;
        }
      }
      button {
        margin: 4px 0;
        flex-grow: 1;
        border-radius: 35px;
        padding-left: 16px;
        border: 1px solid rgba(0, 0, 0, 0.25);
        border-radius: 35px;
        background-color: white;
        text-align: left;
        @media (max-width: 768px) {
          width: 100%;
          margin-top: -25px;
          margin-bottom: 0;
        }
      }
    }
    &:nth-child(2) {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      padding-bottom: 4px;

      button {
        @media (max-width: 768px) {
          /* width: 100%; */
          margin-top: -50px;
          margin-bottom: 0;
        }
        img {
          margin: 0 4px 0 -2px;
        }
        span {
          /* color: #70b5f9; */
        }
      }
    }
  }
`;

const SocialCounts = styled.ul`
  line-height: 1.3;
  display: flex;
  align-items: center;
  overflow: auto;
  color: gray;
  margin: 0 10px;
  padding: 8px 0;
  border-bottom: 1.5px solid #e9e5df;
  list-style: none;
  li {
    font-size: 12px;
    button {
      background-color: white;
      border: none;
      display: flex;
      span {
        padding-top: 0.5px;
        font-size: 12px;
      }
    }
  }
  @media (max-width: 768px) {
    height: 15px;
    margin-top: 10px;
    z-index: index 100;
    li {
      button {
        span {
          margin-top: 6px;
        }
      }
    }
  }
`;

const Article = styled(CommonCard)`
  padding: 0;
  margin-top: 10px;
  margin-bottom: 20px;
  overflow: visible;
  /* position: fixed; */
  background-color: white;
  margin-left: 100px;
  @media (max-width: 768px) {
    width: 100%;
    min-width: 315px;
    padding-top: 0;
    margin-top: 10px;
    margin-left: 0;
    padding: 0;
    a {
      img {
        margin-top: 0;
      }
    }
    /* display: none; */
  }
`;

const SharedActor = styled.div`
  padding-right: 40px;
  flex-wrap: nowrap;
  padding: 12px 16px 0;
  margin-bottom: 8px;
  align-items: center;
  display: flex;
  @media (max-width: 768px) {
    margin-bottom: -40px;
  }
  button {
    img {
      padding-top: 10px;
    }
  }
  a {
    margin-right: 12px;
    flex-grow: 1;
    overflow: hidden;
    display: flex;
    text-decoration: none;

    img {
      width: 48px;
      height: 48px;
      border-radius: 50%;
    }
    & div {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      flex-basis: 0;
      padding-top: 0.5px;
      margin-left: 8px;
      overflow: hidden;
      span {
        text-align: left;
        padding-top: 1px;
        padding-bottom: 1px;
        &:first-child {
          font-size: 16px;
          font-weight: 700;
          color: (0, 0, 0, 1);
        }
        &:nth-child(n + 1) {
          font-size: 12px;
          color: rgba(0, 0, 0, 0.6);
        }
      }
    }
  }

  button {
    position: absolute;
    right: 12px;
    top: 0;
    background: transparent;
    border: none;
    outline: none;
  }
`;

const Description = styled.div`
  padding: 0 16px;
  overflow: hidden;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.9);
  font-size: 14px;
  text-align: left;
`;

const SharedImg = styled.div`
  margin-top: 8px;
  width: 100%;
  display: block;
  position: relative;
  background-color: #f9fafb;
  img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
  @media (max-width: 768px) {
    margin-bottom: 10px;
    object-fit: contain;
    width: 100%;
    height: 350px;
    /* max-height: 570px; */
    /* border: 5px solid red; */
    ///hahaha
  }
`;

const SocialActions = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-start;
  margin: 0;
  min-height: 40px;
  padding: 4px 10px;
  button:hover {
    background-color: lightgray;
  }
  button {
    background-color: white;
    border: none;
    border-radius: 10px;
    display: inline-flex;
    align-items: center;
    justify-items: center;
    /* padding: 8px; */
    padding-left: 35px;
    padding-right: 35px;
    width: 13 0px;
    color: gray;
  }
  @media (max-width: 768px) {
    margin-bottom: 10px;
    button {
      background-color: white;
      border: none;
      border-radius: 10px;
      display: inline-flex;
      align-items: center; /* padding: 8px; */
      padding-left: 25px;
      padding-right: 30px;
      width: 13 0px;
      color: gray;
    }
  }
`;

const mapStateToProps = (state) => {
  return {
    user: state.userState.user,
  };
};

export default Main;
